export enum TipoImprimir {
  PERGUNTAR = 'PERGUNTAR',
  IMPRIMIR = 'IMPRIMIR',
  NADA_A_FAZER = 'NADA_A_FAZER'
}
